import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompressWord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 54 64"
    {...props}
  >
    <rect
      width={53}
      height={63}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#E5E6EB"
      rx={4.5}
    />
    <rect width={38} height={16} x={8} y={44} fill="#4B7EFF" rx={3} />
    <path
      fill="#fff"
      d="M14.39 56.5a.16.16 0 0 1-.1-.033.16.16 0 0 1-.033-.099v-7.436q0-.055.033-.088a.14.14 0 0 1 .1-.044h2.683q.781 0 1.375.275t.913.792q.33.505.33 1.188v3.19q0 .682-.33 1.199a2.1 2.1 0 0 1-.913.781q-.594.275-1.375.275zm1.143-1.155q0 .055.055.055h1.54q.583 0 .924-.363.353-.375.363-.99v-2.783q0-.627-.352-.99-.352-.375-.946-.374h-1.529q-.055 0-.055.055zm8.12 1.265q-.825 0-1.463-.33a2.44 2.44 0 0 1-.99-.957q-.34-.616-.34-1.419v-2.508q0-.792.351-1.397.352-.615.98-.946.637-.34 1.462-.341.837 0 1.463.341.638.33.99.946.352.605.352 1.397v2.508q0 .803-.352 1.419a2.44 2.44 0 0 1-.99.957q-.626.33-1.463.33m0-1.1q.693 0 1.111-.429.418-.43.418-1.133v-2.563q0-.715-.418-1.144-.419-.429-1.11-.429-.683 0-1.1.429-.42.429-.419 1.144v2.563q0 .704.418 1.133t1.1.429m6.8 1.078q-.826 0-1.453-.319a2.38 2.38 0 0 1-.968-.913q-.34-.583-.34-1.353v-2.717q0-.77.34-1.353.34-.584.968-.902.627-.32 1.452-.319.814 0 1.441.308t.968.869.341 1.298q0 .055-.044.099a.12.12 0 0 1-.088.033l-1.012.055q-.132 0-.132-.121 0-.65-.407-1.045-.396-.396-1.067-.396t-1.078.396-.407 1.045v2.805q0 .638.407 1.034t1.078.396q.67 0 1.067-.385.408-.396.407-1.045 0-.12.132-.121l1.012.044q.055 0 .088.033.044.033.044.077 0 .749-.34 1.32-.341.561-.969.869t-1.44.308m3.799-.088q-.078 0-.11-.033-.023-.045.022-.121l2.189-3.663a.055.055 0 0 0 0-.066l-2.19-3.663a1 1 0 0 1-.021-.077q0-.077.11-.077h1.1q.12 0 .165.088l1.606 2.728q.033.066.066 0l1.617-2.728q.043-.088.154-.088h1.1q.076 0 .099.044.033.033-.011.11l-2.19 3.663a.1.1 0 0 0 0 .066l2.19 3.663q.022.066.022.077 0 .077-.11.077h-1.1q-.11 0-.154-.088l-1.617-2.717q-.033-.066-.066 0l-1.617 2.717q-.045.088-.154.088z"
    />
    <rect
      width={28}
      height={4}
      fill="#A9AABC"
      rx={2}
      transform="matrix(-1 0 0 1 37 9)"
    />
    <rect
      width={36}
      height={3}
      fill="#DCDDE5"
      rx={1.5}
      transform="matrix(-1 0 0 1 45 17)"
    />
    <rect
      width={36}
      height={3}
      fill="#DCDDE5"
      rx={1.5}
      transform="matrix(-1 0 0 1 45 23)"
    />
    <rect
      width={36}
      height={3}
      fill="#DCDDE5"
      rx={1.5}
      transform="matrix(-1 0 0 1 45 29)"
    />
    <rect
      width={36}
      height={3}
      fill="#DCDDE5"
      rx={1.5}
      transform="matrix(-1 0 0 1 45 35)"
    />
  </svg>
);
export default SvgCompressWord;
